import React from 'react';
import styles from './UIGamePlayerInfoExtraFooter.module.scss';
import clsx from 'clsx';
import { MERCHANT_IMAGE_PATH } from '../../../utils/gamePieces.ts';
import { GameColor } from '../../../utils/GameColor.ts';
import IconSpecialBuildPhaseFlag from '@static/images/icon_special_build_phase_flag.svg';
import IconArrowWhite from '@static/images/icon_arrow_white.svg';
import { T, Tooltip } from '@colonist/ui';
import { UIGameDice } from '../../../common/UIGameDiceGroup/UIGameDice/UIGameDice.tsx';
import { AnimatedWaitIcon } from '../../../common/AnimatedWaitIcon/index.ts';
import { Timer } from '../../../common/Timer/Timer.tsx';
import { useTimerLowTime } from '../../../hooks/useTimerLowTime.ts';
import { useGameStore } from '../../../store/GameStoreContext.ts';
import { ModeSettingEnum } from '@colonist/types';
export const UIGamePlayerInfoExtraFooter = ({ isSpecialBuildPhaseRequested, isMerchant, isRushNextRobber, isWaiting, playerColor, playerUsername, dice, outOfTurnActionText, timeLeftInSeconds })=>{
    const merchantIcon = MERCHANT_IMAGE_PATH[playerColor];
    const robberIcon = useGameStore((state)=>state.gameClientConfig.robberSkinIcon);
    const usernameColor = GameColor.getPlayerBGDarkHashForMobile(playerColor);
    const isColonistRush = useGameStore((state)=>state.gameSettings.modeSetting === ModeSettingEnum.ColonistRush4P);
    const isLowTime = useTimerLowTime(timeLeftInSeconds !== null && timeLeftInSeconds !== void 0 ? timeLeftInSeconds : 0, timeLeftInSeconds !== undefined);
    const shouldRenderIcons = isSpecialBuildPhaseRequested || isMerchant || isRushNextRobber;
    const shouldRenderContainer = shouldRenderIcons || !!outOfTurnActionText || isWaiting;
    const shouldRenderDice = dice !== undefined;
    const isEmpty = !shouldRenderContainer && !shouldRenderDice;
    if (isEmpty) return null;
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.wrapper
    }, shouldRenderContainer && /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.container, {
            [styles.rush]: isColonistRush
        })
    }, outOfTurnActionText ? /*#__PURE__*/ React.createElement("span", {
        className: styles.outOfTurnActionText
    }, /*#__PURE__*/ React.createElement(T, {
        id: outOfTurnActionText
    }), isWaiting && /*#__PURE__*/ React.createElement(AnimatedWaitIcon, {
        className: styles.waitIcon,
        animationType: "fade",
        color: "white",
        size: "default"
    })) : isWaiting && /*#__PURE__*/ React.createElement(AnimatedWaitIcon, {
        className: styles.waitIcon,
        animationType: "fade",
        color: "white",
        size: "small"
    }), timeLeftInSeconds !== undefined && /*#__PURE__*/ React.createElement(Timer, {
        timeLeftInSeconds: timeLeftInSeconds,
        className: clsx(styles.time, {
            [styles.lowTime]: isLowTime
        })
    }), shouldRenderIcons && /*#__PURE__*/ React.createElement("div", {
        className: styles.icons
    }, isSpecialBuildPhaseRequested && /*#__PURE__*/ React.createElement("img", {
        src: IconSpecialBuildPhaseFlag
    }), isMerchant && /*#__PURE__*/ React.createElement("img", {
        src: merchantIcon
    }), isRushNextRobber && /*#__PURE__*/ React.createElement(Tooltip, {
        title: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tips.rushNextRobber.title"
        }),
        content: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("span", {
            className: styles.usernamePrefix,
            style: {
                color: usernameColor
            }
        }, /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tips.rushNextRobber.body.username",
            options: {
                playerUsername: playerUsername
            }
        })), ' ', /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tips.rushNextRobber.body.1"
        }))
    }, /*#__PURE__*/ React.createElement("span", {
        className: styles.robberIconGroup
    }, /*#__PURE__*/ React.createElement("img", {
        className: styles.arrowIcon,
        src: IconArrowWhite
    }), /*#__PURE__*/ React.createElement("img", {
        src: robberIcon
    }))))), shouldRenderDice && /*#__PURE__*/ React.createElement("div", {
        className: styles.diceGroup
    }, dice.eventDice !== undefined && /*#__PURE__*/ React.createElement(UIGameDice, {
        value: dice.eventDice,
        type: "event",
        active: false,
        className: styles.eventDie
    }), /*#__PURE__*/ React.createElement(UIGameDice, {
        value: dice.dice1,
        type: dice.eventDice !== undefined ? 'standardRed' : 'standardWhite',
        active: false,
        className: styles.die
    }), /*#__PURE__*/ React.createElement(UIGameDice, {
        value: dice.dice2,
        type: "standardWhite",
        active: false,
        className: styles.die
    })));
};
